import { queryOptions } from '@tanstack/react-query'
import { apiGet } from '../../api/client'
import { escapeHtml } from '../../inventoree/format'
import './TicketAppLabel.css'

/**
 * Eticheta "Charisma ERP (Critical)" a unui tichet - `AppPriority::label` din
 * api. Cea mai critica aplicatie de business a aparatelor tichetului, plus
 * cate mai sunt.
 */
export interface TicketAppLabelApp {
  id: number
  name: string
  criticality: number
  criticalityLabel: string
}

export interface TicketAppLabel {
  id: number
  name: string
  criticality: number
  criticalityLabel: string
  text: string
  more: number
  apps: TicketAppLabelApp[]
}

/** Culoarea dupa criticitate: Critical rosu, High portocaliu, Normal albastru, Low gri. */
export function appLabelClass(criticality: number): string {
  if (criticality >= 4) return 'label-danger'
  if (criticality === 3) return 'label-warning'
  if (criticality === 2) return 'label-info'
  return 'label-default'
}

/** "Also: Opera PMS (High), Intranet (Normal)" - titlul de pe "+N". */
export function appLabelTitle(label: TicketAppLabel): string {
  const others = label.apps.filter((a) => a.id !== label.id)
  const all = [label, ...others].map((a) => `${a.name}${a.criticalityLabel ? ` (${a.criticalityLabel})` : ''}`)
  return `Business application${all.length > 1 ? 's' : ''}: ${all.join(', ')}`
}

/**
 * Aceeasi eticheta, ca HTML - pentru celula de subiect a listei, care se
 * deseneaza din siruri (`columns.ts`). Numele aplicatiei e scris de om, deci
 * trece prin `escapeHtml`.
 */
export function appLabelHtml(label: TicketAppLabel | null | undefined): string {
  if (!label || !label.text) return ''
  const more = label.more > 0 ? ` <span class="tk-app-label-more">+${Number(label.more)}</span>` : ''
  return `<span class="label ${appLabelClass(label.criticality)} tk-app-label" title="${escapeHtml(appLabelTitle(label))}"><i class="fas fa-cubes" aria-hidden="true"></i> ${escapeHtml(label.text)}${more}</span> `
}

export interface TicketAppLabelReply {
  ticketId: number
  label: TicketAppLabel | null
}

/** Eticheta fisei - `GET /easeedesk/tickets/{id}/app-label`. */
export function ticketAppLabelQuery(ticketId: number) {
  return queryOptions({
    queryKey: ['business-apps', 'ticket-label', ticketId],
    queryFn: () => apiGet<TicketAppLabelReply>(`/easeedesk/tickets/${ticketId}/app-label`),
    enabled: ticketId > 0,
    staleTime: 60 * 1000,
  })
}
